
import { api } from '../../../lib/api'

export const ADD_NOTIFICATION_REQUEST = 'ADD_NOTIFICATION_REQUEST'
export const ADD_NOTIFICATION_SUCCESS = 'ADD_NOTIFICATION_SUCCESS'
export const ADD_NOTIFICATION_FAILED = 'ADD_NOTIFICATION_FAILED'

export const GET_NOTIFICATION_CATEGORIES_REQUEST = 'GET_NOTIFICATION_CATEGORIES_REQUEST'
export const GET_NOTIFICATION_CATEGORIES_SUCCESS = 'GET_NOTIFICATION_CATEGORIES_SUCCESS'
export const GET_NOTIFICATION_CATEGORIES_FAILED = 'GET_NOTIFICATION_CATEGORIES_FAILED'

export const addNotification = function (name, address, latitude, longitude, radius, link, details, image, category, phone, email) {
    return function (dispatch) {
        dispatch({
            type: ADD_NOTIFICATION_REQUEST
        })
        const data = {
            locationName: name,
            address,
            latitude,
            longitude,
            distance:radius,
            link,
            details,
            picture: image,
            category,
            phone,
            email
        }
        api.addNotification(data).then(addNotificationResponse => {
            dispatch({
                type: ADD_NOTIFICATION_SUCCESS,
                payload: addNotificationResponse
            })
        }).catch(error => {
            dispatch({
                type: ADD_NOTIFICATION_FAILED,
                error
            })
        })
    }
}

export const getNotificationCategories = () => {
    return (dispatch) => {
        dispatch({
            type: GET_NOTIFICATION_CATEGORIES_REQUEST
        })
        api.getNotificationCategories().then(getNotificationCategoriesResponse => {
            dispatch({
                type: GET_NOTIFICATION_CATEGORIES_SUCCESS,
                payload: getNotificationCategoriesResponse
            })
        }).catch(error => {
            dispatch({
                type: GET_NOTIFICATION_CATEGORIES_FAILED,
                error
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/notification/add-notification.js